<template>
  <section class="section">
    <modal-columns
      v-if="showModalColumn"
      :close="setShowModalColumn"
      :saveColumns="saveCustomerColumns"
      :columnsList="this.authentication.servicesColumn"
    />
    <nav class="level is-vcentered">
      <div class="level-left">
        <div class="level-item">
          <img class="level-item-img" src="@/assets/icon/servicios-level.png" alt="Servicios">
          <h1 class="title">Servicios</h1>
        </div>
      </div>
    </nav>
    <main class="inner-section">
      <div class="container">
        <div class="box">
          <div class="columns is-multiline">
            <!-- Acciones -->
            <div class="column is-12">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-3">
                  <v-select
                    class="input_select"
                    label="name"
                    placeholder='Filtros'
                    v-model="filterSelected"
                    :reduce="filter => filter.id"
                    :options="filterList"
                    @input="setFilter"
                  >
                  </v-select>
                </div>
                <div class="column is-3" v-if="filterType === 'search'">
                  <div class="field">
                    <div class="control has-icons-right">
                      <input
                        class="input is-rounded input_ibs"
                        type="text"
                        placeholder="Buscar"
                        v-model="searchText"
                      >
                      <span class="icon is-right">
                        <img class="icon_search" src="@/assets/icon/search.png">
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Select -->
                <div class="column is-3"  v-if="filterType === 'list'">
                  <v-select
                    class="input_select"
                    label="name"
                    :placeholder='labelSelected'
                    v-model="currentValueOfTheSelect"
                    :reduce="data => data.id"
                    :options="selectedFilterData"
                  >
                  <!-- @input="setStatus" -->
                  </v-select>
                </div>
                <div class="column is-3" v-if="filterType === 'rangedate'">
                  <div class="field field_calendar">
                    <div class="control has-icons-right" :class="{ 'is-danger-calendar': vverrors.has('date') }">
                      <v-date-picker
                        class="input_calendar"
                        clearable
                        is-range
                        mode='range'
                        v-model='date'
                        name="date"
                        :input-props='{ placeholder: labelSelected }'
                        v-validate="'required'"
                        is-required
                      />
                    </div>
                  </div>
                </div>
                <div class="column is-2"  v-if="filterType !== ''">
                  <button
                    class="button button_ibs is-rounded sm_btn"
                    @click="setFilterValue"
                  >Filtrar</button>
                </div>

                <!-- Buscador -->
                <!-- <div class="column is-3">
                  <div class="field">
                    <div class="control has-icons-right">
                      <input
                        class="input is-rounded input_ibs"
                        type="text"
                        placeholder="Buscar"
                        v-model="searchText"
                        @input="searchUser"
                      >
                      <span class="icon is-right">
                        <img class="icon_search" src="@/assets/icon/search.png">
                      </span>
                    </div>
                  </div>
                </div> -->
                <!-- Select -->
                <!-- <div class="column is-3">
                  <v-select
                    class="input_select"
                    label="name"
                    placeholder='Tipo de Servicio'
                    v-model="statusSelected"
                    :reduce="status => status.id"
                    :options="serviceList"
                    @input="setStatus"
                  >
                  </v-select>
                </div> -->
                <!-- <div class="column is-12">
                  <button
                    class="is-pulled-right button button_ibs is-rounded"
                    @click="$router.push({ name: 'nuevo-servicio' })"
                  >
                    Solicitar Servicio
                </button>
                </div> -->
              </div>
            </div>
            <!-- Datos -->
             <div class="column is-12" v-if="filterSelectedList.length > 0">
              <span class="tag"  v-for="(element, index) in filterSelectedList" :key="index">
                <template
                  v-if="
                    Object.keys(element)[0] === 'inspection_date' ||
                    Object.keys(element)[0] === 'reception_date' ||
                    Object.keys(element)[0] === 'delivery_date' ||
                    Object.keys(element)[0] === 'payment_date' ||
                    Object.keys(element)[0] === 'billing_date' ||
                    Object.keys(element)[0] === 'send_invoice_date' ||
                    Object.keys(element)[0] === 'created_at'"
                >
                  <strong>{{searchKeyName(Object.keys(element))}}</strong>: {{formatDate(element[Object.keys(element)[0]].start, 'DD MMMM YYYY')}} - {{formatDate(element[Object.keys(element)[0]].end, 'DD MMMM YYYY')}}
                </template>
                <template v-else>
                  <strong>{{searchKeyName(Object.keys(element))}}</strong>: {{getCatalogValue(Object.keys(element)[0], element[Object.keys(element)[0]])}}
                </template>
                <button class="delete is-small" @click="deleteFilter(Object.keys(element)[0])"></button>
              </span>
            </div>
            <div class="column is-12">
              <span class="config-table is-pulled-right" @click="setShowModalColumn">
                Configurar Columnas
              </span>
            </div>
            <div class="column is-12" v-if="!loadingColumn">
              <base-table
                class="is-striped-2 is-fullwidth is-hoverable"
                :columns="columnsData"
                :data="servicesList"
                :loading=loading
              >
                <!-- <div
                  slot="config"
                  slot-scope="scope"
                >
                  <div class="is_btn_status" :class="{ 'is_btn_status_process' : scope.row.service_status_id === inProcess }">
                    {{ scope.row.service_status_id === inProcess ? 'En Proceso' : 'Terminado' }}
                  </div>
                </div> -->
                <div
                  slot="action"
                  slot-scope="action"
                  class="icon_table_content"
                >
                  <img class="icon_table_action" src="@/assets/icon/upload_icon_grey.png" alt="download" @click="downloadService(action.row.id)">
                  <img class="icon_small" src="@/assets/icon/link_icon_grey.png" alt="link" @click="getLinkService(action.row.id)">
                  <img class="icon_table_action" src="@/assets/icon/share_icon_grey.png" alt="share" @click="shareService(action.row.id)">
                </div>
              </base-table>
            </div>
            <div class="column is-12">
              <div class="columns is-multiline is-vcentered">
                <div class="column is-12">
                  <base-pagination
                    :page="page"
                    :pages="parseInt(pages)"
                    :action="paginator"
                    :loading="loading"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import service from '@/constants/catalogs/services'
import currency from '@/constants/catalogs/currency'
import months from '@/constants/catalogs/months'
import paymentMethods from '@/constants/catalogs/paymentMethods'
import wayToPay from '@/constants/catalogs/wayToPay'
import customersUserType from '@/constants/catalogs/customersUserType'
import billingStatus from '@/constants/catalogs/billingStatus'
import billFor from '@/constants/catalogs/billFor'
import moment from 'moment'

import mixins from '../../mixins/formats'
import ModalColumns from '../../components/services/ModalColumns.vue'

const DEFAULT_DISPLAY_SIZE = 10

export default {
  name: 'Services',
  mixins: [mixins],
  components: {
    BaseTable: () => import('@/components/Table.vue'),
    BasePagination: () => import('@/components/BasePagination.vue'),
    ModalColumns
  },
  data () {
    return {
      inProcess: 1,
      page: 1,
      pages: 1,
      loading: false,
      searchText: '',
      statusSelected: '',
      servicesList: [],
      columnsData: [
        {
          id: 'reference',
          header: 'Referencia Interna',
          class: 'column-mobile',
          accessor: (row) => `${row.reference}`,
          link: true,
          type: 'link',
          route: (row) => ({ name: 'detalle-servicio', params: { serviceId: row.id } })
        },
        { id: 'serviceName', header: 'Servicio', class: 'is-hidden-mobile' },
        { id: 'providerName', header: 'Proveedor', class: 'column-mobile is-hidden-touch' },
        { id: 'po_number', header: 'PO', class: 'is-hidden-mobile' },
        { id: 'container_number', header: 'No. Contenedor', class: 'column-mobile is-hidden-touch' },
        { id: 'inspection_date', header: 'Fecha Inspección', class: 'is-hidden-mobile', accessor: (row) => moment(row.inspection_date).format('DD-MM-YYYY') },
        { id: 'month', header: 'Mes', class: 'column-mobile is-hidden-touch' },
        { id: 'invoice_number', header: 'No. de Factura', class: 'column-mobile' },
        { id: 'invoice_amount', header: 'Monto Factura', class: 'column-mobile' },
        { id: 'country_ccounting', header: 'País', class: 'column-mobile' }
        // { id: 'config', name: 'config', header: 'Estatus', class: 'is-hidden-mobile' },
        // { id: 'action', name: 'action', header: 'Acciones', class: 'has-text-centered' }
      ],
      serviceList: service,
      filterSelected: null,
      filterType: '',
      filterValue: null,
      labelSelected: '',
      filterSelectedList: [],
      filterList: [
        { id: 'reference', name: 'Referencia', type: 'search' },
        { id: 'customer_id', name: 'Cliente', type: 'list' },
        { id: 'service_id', name: 'Servicio', type: 'list' },
        { id: 'po_number', name: 'Número PO', type: 'search' },
        { id: 'provider_id', name: 'Proveedor', type: 'list' },
        { id: 'container_number', name: 'No. Contenedor', type: 'search' },
        { id: 'inspection_date', name: 'Fecha De Inspección', type: 'rangedate' },
        { id: 'month_id', name: 'Mes', type: 'list' },
        { id: 'invoice_number', name: 'No. De Factura', type: 'search' },
        { id: 'invoice_amount', name: 'Monto Factura', type: 'search' },
        { id: 'billing_status_id', name: 'Estatus', type: 'list' },
        // { id: 'man_days', name: 'Man-days', type: 'list' },
        { id: 'country_ccounting', name: 'País', type: 'search' }
      ],
      date: {
        start: new Date(),
        end: new Date()
      },
      currentValueOfTheSelect: null,
      currencyList: currency,
      paymentMethodList: paymentMethods,
      wayToPayList: wayToPay,
      monthsList: months,
      customersUserType: customersUserType,
      billingStatus: billingStatus,
      billFor: billFor,
      showModalColumn: false,
      loadingColumn: false
    }
  },
  computed: {
    ...mapState({
      authentication: state => state.authentication
    })
  },
  methods: {
    ...mapActions(['getServices', 'getCustomers', 'saveServicesColumn', 'validateSession', 'getProvidersCatalog']),
    getServicesList (page, search, status = '', filters = [], orderBy = '', orderType = '', year = '') {
      this.loading = true
      this.getServices({ page: page, limit: DEFAULT_DISPLAY_SIZE, search: search, status: status, filters, orderBy: orderBy, orderType: orderType, year: year || '' })
        .then((resp) => {
          this.pages = resp.totalPages
          this.servicesList = resp.services
          this.loading = false
        })
    },
    searchUser ({ target }) {
      this.page = 1
      this.loading = true
      if (target.value.length >= 3 || target.value.length === 0) {
        this.searchText = target.value.length === 0 ? '' : target.value
        this.$router.push({ name: 'servicios', query: { page: this.page, search: target.value, status: this.statusSelected } })
        this.getServicesList(this.page, target.value, this.statusSelected)
      }
    },
    setStatus (status) {
      if (status === null) { status = '' }
      this.statusSelected = status
      this.page = 1
      this.loading = true
      this.$router.push({ name: 'servicios', query: { page: this.page, search: this.searchText, status: this.statusSelected } })
      this.getServicesList(this.page, this.searchText, status)
    },
    paginator (page) {
      this.page = page
      this.$router.push({ name: 'servicios', query: { page: this.page, search: this.searchText, status: this.statusSelected } })
      this.loading = true
      this.getServicesList(this.page, this.searchText, this.statusSelected)
    },
    // @TODO: Implementar servicios de descarga, obtencion de url y compartir
    downloadService () {
    },
    getLinkService () {
    },
    shareService () {
    },
    async setFilter (filterId) {
      this.showErrorFilter = false
      this.selectedFilterData = []
      console.log(filterId)
      if (filterId === null) {
        filterId = ''
        this.filterType = ''
      } else {
        switch (filterId) {
          case 'customer_id': {
            // @TODO: Validar con los filtros seleccionados
            const { success, customers } = await this.getCustomers({ page: 1, limit: 100 })
            this.selectedFilterDatacustomers = success ? customers : []
            this.selectedFilterData = success ? customers : ''
            const isPartnerSelected = this.filterSelectedList.find(element => element.partner_id)
            if (isPartnerSelected) {
              this.selectedFilterData = this.selectedFilterData.filter(customer => customer.partner_id === isPartnerSelected.partner_id)
            }
            break
          }
          case 'provider_id': {
            console.log('entra')
            // @TODO: Validar con los filtros seleccionados
            const { success, providers } = await this.getProvidersCatalog()
            this.selectedFilterDataproviders = success ? providers : []
            this.selectedFilterData = success ? providers : ''
            break
          }
          case 'client_type': {
            this.selectedFilterData = this.customersUserType
            break
          }
          case 'currency_id': {
            this.selectedFilterData = this.currencyList
            break
          }
          case 'month_id': {
            this.selectedFilterData = this.monthsList
            break
          }
          case 'billing_status_id': {
            this.selectedFilterData = this.billingStatus
            break
          }
          case 'billing_for_id': {
            this.selectedFilterData = this.billFor
            break
          }
          case 'comision': {
            this.selectedFilterData = this.comisionList
            break
          }
          case 'man_days': {
            this.selectedFilterData = this.manDaysList
            break
          }
          case 'service_id': {
            this.selectedFilterData = this.serviceList
            break
          }
          default: break
        }
        const filterType = this.filterList.find(filter => filter.id === filterId)
        this.filterType = filterType.type
        this.labelSelected = filterType.name
      }
    },
    setFilterValue () {
      switch (this.filterType) {
        case 'search': {
          this.filterValue = this.searchText
          this.searchText = ''
          break
        }
        case 'list': {
          this.filterValue = this.currentValueOfTheSelect
          this.currentValueOfTheSelect = ''
          break
        }
        case 'rangedate': {
          this.filterValue = this.date
          this.date = null
          break
        }
        default: break
      }
      this.page = 1
      this.showErrorFilter = false
      const filterExist = this.filterSelectedList.find(filter => {
        return filter[this.filterSelected]
      })
      if (!this.filterValue) this.showErrorFilter = true
      else {
        this.loading = true
        if (!filterExist) this.filterSelectedList.push({ [this.filterSelected]: this.filterValue })
        else filterExist[this.filterSelected] = this.filterValue
        this.$router.push({ name: 'servicios', query: { page: this.page, search: this.searchTextGlobal, status: this.statusSelected, orderBy: this.orderBy, orderType: this.orderType } })
        this.getServicesList(this.page, this.searchTextGlobal, status, this.filterSelectedList, this.orderBy, this.orderType, this.activeYear)
        this.filterType = ''
        this.filterValue = null
        this.filterSelected = ''
      }
    },
    deleteFilter (key) {
      this.filterSelectedList = this.filterSelectedList.filter(element => Object.keys(element)[0] !== key)
      this.getServicesList(this.page, this.searchTextGlobal, status, this.filterSelectedList, this.orderBy, this.orderType, this.activeYear)
    },
    searchKeyName (key) {
      const filter = this.filterList.find(element => element.id === key[0])
      return filter ? filter.name : 'N/A'
    },
    getCatalogValue (filterId, value) {
      let newValue = null
      console.log(filterId)
      switch (filterId) {
        case 'partner_id': {
          const catalogElement = this.selectedFilterDatapartner.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'service_id': {
          const catalogElement = this.serviceList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'customer_id': {
          const catalogElement = this.selectedFilterDatacustomers.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'provider_id': {
          const catalogElement = this.selectedFilterDataproviders.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'commercial_executive_id': {
          const catalogElement = this.selectedFilterDataCommercial.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'cn_coordinator': {
          const catalogElement = this.selectedFilterDataCnCoordinator.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'mx_coordinator': {
          const catalogElement = this.selectedFilterDataMxCoordinator.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'billing_status_id': {
          const catalogElement = this.billingStatus.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'client_type': {
          const catalogElement = this.customersUserType.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'currency_id': {
          const catalogElement = this.currencyList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'month_id': {
          const catalogElement = this.monthsList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'billing_for_id': {
          const catalogElement = this.billFor.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        case 'comision': {
          const catalogElement = this.comisionList.find(element => element.id === value)
          newValue = catalogElement ? catalogElement.name : ''
          break
        }
        default:
          newValue = value
          break
      }
      return newValue
    },
    setShowModalColumn () {
      this.showModalColumn = !this.showModalColumn
    },
    async saveCustomerColumns (columns) {
      this.loadingColumn = true
      const response = await this.saveServicesColumn(columns)
      if (response) {
        this.columnsData = columns
        this.columnsData = this.columnsData.sort((a, b) => a.lastPosition - b.lastPosition)
        this.setShowModalColumn()
        this.authentication.servicesColumn = columns
      }
      this.loadingColumn = false
    }
  },
  beforeMount () {
    this.loading = true
    if (this.authentication.servicesColumn) {
      this.columnsData = this.authentication.servicesColumn.map(col => {
        return col.id === 'reference'
          ? { ...col, accessor: (row) => `${row.reference}`, route: (row) => ({ name: 'detalle-servicio', params: { serviceId: row.id } }) }
          : col.id === 'inspection_date'
            ? { ...col, accessor: (row) => moment(row.inspection_date).format('DD-MM-YYYY') }
            : col
      })
      this.columnsData = this.columnsData.sort((a, b) => a.lastPosition - b.lastPosition)
    }
    const { page, search, status } = this.$router.history.current.query
    this.page = (page === '' || page === undefined) ? this.page : parseInt(page, 10)
    this.searchText = search === '' ? this.searchText : search
    this.statusSelected = !status ? this.statusSelected : status
    this.getServicesList(this.page, this.searchText, this.statusSelected)
  }
}
</script>

<style lang="scss" scoped>
  .section {
    width: 100%;
    min-height: calc(100vh - 90px);
    padding: 0;
  }
  .input {
    font-size: 14px;
  }
  .field.is-grouped {
    display: flex;
    justify-content: flex-end;
  }

  .icon_table_action {
    max-width: 15px;
    margin: 5px;
  }
  .icon_small {
    max-width: 22px;
    margin: 5px;
    cursor: pointer;
  }
  .icon_table_content {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .config-table {
    font-size: 12px;
    cursor: pointer;
    color: #00b00c;
  }
</style>
